import { Image } from '@rover/kibble/core';
import { Props as ImageProps } from '@rover/kibble/core/Image';

import GoodPupHorizontal from '../../SeoLocation/pages/DogTraining/components/images/goodpup-horizontal.svg?url';

const GoodPupLogo = (
  props: Omit<ImageProps, 'src' | 'description' | 'width' | 'height'>
): JSX.Element => {
  return (
    <Image
      src={GoodPupHorizontal}
      description="GoodPup Logo"
      width={200}
      height={45}
      my={['8x', '16x']}
      {...props}
    />
  );
};

export default GoodPupLogo;
